

$('.button_parent').on("click", function toggle_child_button() {

    let card = $(this).attr("data-relation");

    if ($('#' + card + '').length > 0) {
        $('.button_parent[aria-controls="'+card+'"]').toggleClass("expanded");
        $('#' + card + '').toggleClass("expanded");
    }

});